import React, { useEffect, useState } from "react";

import Hor_header from "../header/hor_header";
import Ver_header from "../header/ver_header";
import Footer from "../footer/footer";
import { API_URL } from "../constant";
import { useNavigate, useParams } from "react-router-dom";

import "react-datepicker/dist/react-datepicker.css";
import swal from "sweetalert";

function AddBlocks() {

    /********************************************* */
    const [stateData, setStateData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [state, setState] = useState("");
    const [district, setDistrict] = useState("");
    const [block, setBlock] = useState("");
    const params = useParams();



    const navegate = useNavigate();
    let clickCancel = () => {
        return navegate('/');
    }
  useEffect(() => {
         if(localStorage.getItem("userLoginType")!='Admin'){
              return navegate('/');
         } 
     },[1])

    useEffect(() => {
        getStateData();
    }, [1]);

    useEffect(async () => {
        document.title = (params?.id)?'Edit Blocks':'Add Blocks';
         if (params?.id) {
            setState(params?.stateId);
            setDistrict(params?.districtId);
            setBlock(params?.name)
            if (params?.stateId) {

                let state_id = params?.stateId;
                const regDataDistrict = {
                    method: 'Post',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ 'state_id': state_id })
                }
                const getDistrict = await fetch(API_URL + 'admin/district', regDataDistrict);
                const getdataDistrict = await getDistrict.json();
              
                if (getdataDistrict.Rdata.length > 0) {
                    setDistrictData(getdataDistrict.Rdata);
                }
            }

           
        }
       
    }, []);

    //****************Handle State************************* */

    const handleState = async (e) => {
        setState(e.target.value)
        if (e.target.value) {
            let state_id = e.target.value;
            const regDataDistrict = {
                method: 'Post',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 'state_id': state_id })
            }
            const getDistrict = await fetch(API_URL + 'admin/district', regDataDistrict);
            const getdataDistrict = await getDistrict.json();
        
            if (getdataDistrict.Rdata.length > 0) {
                setDistrictData(getdataDistrict.Rdata);
            }
        }
    }


    /************************Hnadle District************************ */

    const handleDistrict = (e) => {
        setDistrict(e.target.value);
    }

    /**********************Handle Blocks******************* */

    const handleBlocks = (e) => {
        setBlock(e.target.value);
    }

    /********State List Api*********** */
    let getStateData = async () => {
        const regDataState = {
            method: 'Get',
            headers: { 'Content-Type': 'application/json' }
        }
        const getState = await fetch(API_URL + 'admin/state', regDataState);
        const getdatastate = await getState.json();
        setStateData(getdatastate);
    }

    /************************Validation****************************** */
    const handleValidation = () => {
        let formIsValid = true;
    
        if (!state && state === "") {
            formIsValid = false;
            swal('Please Select State');
        }
        if (!district && state === "") {
            formIsValid = false;
            swal('Please Select District');
        }
        if (!block) {
            formIsValid = false;
            swal('Please Enter Block');
        }
       
        
        
        return formIsValid;
    }

    /******************Add Blocks******************* */

    const AddBlocks = async () => {

        let formData = {
            "name": block,
            "district_id": district
        };

        const regDatas = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        }

        const getResps = await fetch(API_URL + 'admin/add-block', regDatas);
        const getDatas = await getResps.json();

        swal(getDatas.msg);

    }

    /**************************Update Blocks************************* */


    const UpdateBlocksName = async () => {

        let formData = {

            'name': block,
            'id': params?.id

        };

        const regDatas = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        }

        const getResps = await fetch(API_URL + 'admin/update-block', regDatas);
        const getDatas = await getResps.json();

        swal(getDatas.msg);

    }


    const handleSubmit = (events) => {
        if(handleValidation()){
            events.preventDefault();
            if (params?.id) {
                UpdateBlocksName();
            } else {
                AddBlocks();
            }
        }
      

    }
    






    return (
        <div className="container-scroller">

            <Hor_header />

            <div className="container-fluid page-body-wrapper">


                <Ver_header />


                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className="row">

                            <div className="col-12 grid-margin">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">{(params?.id)?"Update Block":"Add Block"}</h4>
                                        {/* <form className="form-sample"  > */}

                                       
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-sm-12">Select State *</label>
                                                    <div className="col-sm-12">
                                                        <select className="form-control" value={state} onChange={handleState} required disabled={(params?.id)?true:false}>
                                                            <option value="">Select State</option>
                                                            {stateData.map(states => (
                                                                <option value={states.id}>{states.state}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-sm-12">Select District *</label>
                                                    <div className="col-sm-12">
                                                        <select className="form-control" value={district} onChange={handleDistrict} required disabled={(params?.id)?true:false}>
                                                            <option value="">Select District</option>
                                                            {districtData.map(district => (
                                                                <option value={district.id}>{district.name} </option>

                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-sm-12">Block Name *</label>
                                                    <div className="col-sm-12">
                                                        <input value={block} type="text" className="form-control" autoComplete="off" onChange={handleBlocks} required />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>



                                        <button type="submit" className="btn btn-primary mr-2" onClick={handleSubmit}>Submit</button>
                                        <button type="button" className="btn btn-light" onClick={clickCancel}>Cancel</button>
                                        {/* </form> */}
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                    <Footer />

                </div>

            </div>


        </div>


    );
}

export default AddBlocks;